import { SeasonCalendarPeriodDto } from '@app/data/dtos/manage-vacations/manage-vacations.dto';
import {
  MomoCreateProposalDto,
  MomoManageVacationsProposalsDto,
  MomoSeasonsProposalDto
} from '@app/data/dtos/manage-vacations/momo/momo-manage-vacations.dto';
import { SEASONS } from '@app/entities/enums/manage-vacations/manage-vacations.enum';
import {
  MomoManageVacationsProposals,
  MomoProposal,
  MomoSeasonProposal,
  MomoSeasonsProposal
} from '@app/entities/models/manage-vacations/momo-manage-vacations.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapMomoVacationsProposals: MapFromFn<MomoManageVacationsProposalsDto, MomoManageVacationsProposals> = (
  value: MomoManageVacationsProposalsDto
): MomoManageVacationsProposals =>
  Builder.forModel(MomoManageVacationsProposals)
    .preferences(value ? value.preferences.map(mapMomoSeasonProposal) : [])
    .observations(value ? value.observations : '')
    .titleMessage(value ? value.vacation_proposal_message : '')
    .build();

const mapMomoSeasonAsSeasonProposal = (
  seasonId: SEASONS,
  proposals: SeasonCalendarPeriodDto[] | undefined
): MomoSeasonProposal => {
  let title: string;
  let img: string;

  if (seasonId === SEASONS.WINTER) {
    title = 'CHOOSE_VACATIONS.CRITERIA.WINTER';
    img = 'temperatureSnowflakeRegular';
  } else {
    title = 'CHOOSE_VACATIONS.CRITERIA.SUMMER';
    img = 'weatherSunRegular';
  }

  return Builder.forModel(MomoSeasonProposal)
    .id(seasonId)
    .title(title)
    .img(img)
    .proposals((proposals ?? []).map(mapMomoPeriods))
    .build();
};

export const mapMomoSeasonProposal: MapFromFn<MomoSeasonsProposalDto, MomoSeasonsProposal> = (
  value: MomoSeasonsProposalDto
): MomoSeasonsProposal =>
  Builder.forModel(MomoSeasonsProposal)
    .winter(mapMomoSeasonAsSeasonProposal(SEASONS.WINTER, value?.winter))
    .summer(mapMomoSeasonAsSeasonProposal(SEASONS.SUMMER, value?.summer))
    .build();

export const mapMomoSeasonProposalDto: MapFromFn<MomoSeasonsProposal, MomoSeasonsProposalDto> = (
  value: MomoSeasonsProposal
): MomoSeasonsProposalDto => ({
  winter: value?.winter?.proposals?.map(mapMomoProposalSeasonDto) ?? [],
  summer: value?.summer?.proposals?.map(mapMomoProposalSeasonDto) ?? []
});

export const mapMomoProposalSeasonDto: MapFromFn<MomoProposal, SeasonCalendarPeriodDto> = (
  value: MomoProposal
): SeasonCalendarPeriodDto =>
  Builder.forDto<SeasonCalendarPeriodDto>().start_date(value.startDate).end_date(value.endDate).build();

export const mapMomoCreateProposalDto = (proposals: MomoManageVacationsProposals) => {
  const createProposal: MomoCreateProposalDto = {
    preferences: [],
    observations: ''
  };
  createProposal.preferences = proposals?.preferences?.map(mapMomoSeasonProposalDto) || [];
  createProposal.observations = proposals?.observations || '';

  return createProposal;
};

export const mapMomoPeriods: MapFromFn<SeasonCalendarPeriodDto, MomoProposal> = (value) =>
  Builder.forModel(MomoProposal)
    .id(value.id)
    .startDate(value.start_date)
    .endDate(value.end_date)
    .description(value.description)
    .duration(value.duration)
    .probability(value.probability)
    .build();
